var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useReport } from '@tencent/dz-report';
import { useEffect } from 'react';
import { useMobileModel } from '../../../hooks';
export var useReportService = function (params) {
    var report = useReport();
    var autoPhoneEnabled = useMobileModel().autoPhoneEnabled;
    useEffect(function () {
        formExposure();
    }, []);
    var formExposure = function () {
        report.exposure(__assign(__assign({}, params), { element_chinese_type: '表单', element_type: 'form' }));
        if (autoPhoneEnabled) {
            report.exposure(__assign(__assign({}, params), { element_type: 'form_authorize_clause', element_chinese_type: '表单_授权条款' }));
            report.exposure(__assign(__assign({}, params), { element_type: 'form_authorize_button', element_chinese_type: '表单_授权按钮' }));
        }
    };
    var formPopupExposure = function () {
        report.exposure(__assign(__assign({}, params), { element_type: 'form_popup', element_chinese_type: '表单_弹窗' }));
    };
    var formAuthButtonClick = function () {
        report.click(__assign(__assign({}, params), { element_type: 'form_authorize_button', element_chinese_type: '表单_授权按钮' }));
    };
    var formSubmit = function (formValue) {
        var name = formValue.name, phone = formValue.phone, content = formValue.content;
        report.click(__assign(__assign({}, params), { element_type: 'form_send', element_chinese_type: '表单_发送', element_content: name ? name + "^" + phone + "^" + content : phone + "^" + content }));
    };
    var formPopupSubmit = function () {
        formClauseClick(true);
        report.click(__assign(__assign({}, params), { element_type: 'form_popup_authorize', element_chinese_type: '表单_弹窗_授权' }));
    };
    var formPopupCancel = function () {
        report.click(__assign(__assign({}, params), { element_type: 'form_popup_cancel', element_chinese_type: '表单_弹窗_取消' }));
    };
    var formClauseClick = function (checked) {
        report.click(__assign(__assign({}, params), { element_type: 'form_authorize_clause', element_chinese_type: '表单_授权条款', element_content: checked ? '是' : '否' }));
    };
    return {
        formExposure: formExposure,
        formPopupExposure: formPopupExposure,
        formAuthButtonClick: formAuthButtonClick,
        formSubmit: formSubmit,
        formCommonParams: params,
        formPopupSubmit: formPopupSubmit,
        formClauseClick: formClauseClick,
        formPopupCancel: formPopupCancel,
    };
};
